<template>
  <div>
    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">SESIONES ORDINARIAS CAMARA DE DIP</h2>
            </div>
          </div>
        </div>
      </div>
    </section>


    <div class="container">

      <div class="columns mt-01">
        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion1.jpg" alt="Se presentó ante la @Mx_Diputados iniciativa"/>
          </div>
          <p class="has-text-justified">Se presentó ante la @Mx_Diputados iniciativa para garantizar guarderías para hijos de trabajadores eventuales. #LegislandoContigo</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion2.jpg" alt="Aprobamos la Reforma a los arts. 150 y 164 del Código Penal Federal"/>
          </div>
          <p class="has-text-justified">Aprobamos la Reforma a los arts. 150 y 164 del Código Penal Federal @Mx_Diputados #SesiónDiputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion3.jpg" alt="Felicito a Jackie Nava por su triunfo como campeona internacional de box"/>
          </div>
          <p class="has-text-justified">Felicito a Jackie Nava por su triunfo como campeona internacional de box. @Mx_Diputados #DeporteInternacional.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion4.jpg" alt="Posicionamiento de los partidos sobre reformas a la Ley de Desarrollo Rural Sustentable"/>
          </div>
          <p class="has-text-justified">Posicionamiento de los partidos sobre reformas a la Ley de Desarrollo Rural Sustentable en @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion5.jpg" alt="En Tribuna hablé sobre el dictamen de Comisiones de Protección Civil y Comunicaciones. @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">En Tribuna hablé sobre el dictamen de Comisiones de Protección Civil y Comunicaciones. @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion6.jpg" alt="Es importante fortalecer las políticas públicas en materia de protección civil para salvar el mayor número de vidas. @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Es importante fortalecer las políticas públicas en materia de protección civil para salvar el mayor número de vidas. @Mx_Diputados.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion7.jpg" alt="Es importante fortalecer las políticas públicas en materia de protección civil para salvar el mayor número de vidas. @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Es importante fortalecer las políticas públicas en materia de protección civil para salvar el mayor número de vidas. @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion8.jpg" alt="Fue presentada ante @Mx_Diputados la iniciativa sobre trámite de titulación y expedición de cédula fiscal."/>
          </div>
          <p class="has-text-justified">Fue presentada ante @Mx_Diputados la iniciativa sobre trámite de titulación y expedición de cédula fiscal.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion9.jpg" alt="También se presentó la iniciativa que reforma el Código Penal Federal. @Mx_Diputados"/>
          </div>
          <p class="has-text-justified">También se presentó la iniciativa que reforma el Código Penal Federal. @Mx_Diputados.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion10.jpg" alt="También se presentó la iniciativa que reforma el Código Penal Federal. @Mx_Diputados"/>
          </div>
          <p class="has-text-justified">También se presentó la iniciativa que reforma el Código Penal Federal. @Mx_Diputados</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion11.jpg" alt="Se presenta en la Cámara de @Mx_Diputados dos iniciativas en materia de reducción de legisladores. #LegislandoContigo #SesiónOrdinaria."/>
          </div>
          <p class="has-text-justified">Se presenta en la Cámara de @Mx_Diputados dos iniciativas en materia de reducción de legisladores. #LegislandoContigo #SesiónOrdinaria.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion12.jpg" alt="Se propone garantizar la representación indígena en postulación de candidatos. @Mx_Diputados #LegislandoContigo."/>
          </div>
          <p class="has-text-justified">Se propone garantizar la representación indígena en postulación de candidatos. @Mx_Diputados #LegislandoContigo</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion13.jpg" alt="Analizamos la iniciativa sobre concesiones y asignaciones de aguas nacionales. #LegislandoContigo desde @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Analizamos la iniciativa sobre concesiones y asignaciones de aguas nacionales. #LegislandoContigo desde @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion14.jpg" alt="Hoy en @Mx_Diputados se realiza posicionamiento de los partidos sobre la reforma a la Ley de Transición Energética."/>
          </div>
          <p class="has-text-justified">Hoy en @Mx_Diputados se realiza posicionamiento de los partidos sobre la reforma a la Ley de Transición Energética.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion15.jpg" alt="Hoy en #SesiónOrdinaria de @Mx_Diputados, escuchamos a nuestras diputadas sobre Ley Gral. de Acceso de Mujeres a una Vida Libre de Violencia"/>
          </div>
          <p class="has-text-justified">Hoy en #SesiónOrdinaria de @Mx_Diputados, escuchamos a nuestras diputadas sobre Ley Gral. de Acceso de Mujeres a una Vida Libre de Violencia</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion16.jpg" alt="Aprobamos Adicionar Diversas Disposiciones al Reglamente de la Cámara de Diputados. @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Aprobamos Adicionar Diversas Disposiciones al Reglamente de la Cámara de Diputados. @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion17.jpg" alt="Me encuentro en la 9a Reunión Ordinaria de la Comisión de Trabajo y Previsión Social, @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Me encuentro en la 9a Reunión Ordinaria de la Comisión de Trabajo y Previsión Social, @Mx_Diputados.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion18.jpg" alt="Se presentó la iniciativa que reforma Arts. 12 y 19 de la Ley Gral. de Educación. @Mx_Diputados #legislandocontigo."/>
          </div>
          <p class="has-text-justified">Se presentó la iniciativa que reforma Arts. 12 y 19 de la Ley Gral. de Educación. @Mx_Diputados #legislandocontigo.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion19.jpg" alt="También fue presentada la iniciativa que reforma la Ley Gral. del Sistema Nacional de Seguridad Pública."/>
          </div>
          <p class="has-text-justified">También fue presentada la iniciativa que reforma la Ley Gral. del Sistema Nacional de Seguridad Pública.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion20.jpg" alt="Estamos en sesión previa a la #SesiónOrdinaria de @Mx_Diputados"/>
          </div>
          <p class="has-text-justified">Estamos en sesión previa a la #SesiónOrdinaria de @Mx_Diputados</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion21.jpg" alt="César Camacho Quiroz @CCQ_PRI presentó propuesta para derogar el arraigo, que se contrapone a los principios del sistema de justicia penal."/>
          </div>
          <p class="has-text-justified">César Camacho Quiroz @CCQ_PRI presentó propuesta para derogar el arraigo, que se contrapone a los principios del sistema de justicia penal.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion22.jpg" alt="Realizamos pocisionamiento de los partidos sobre exhorto a autoridades que ejercen funciones jurisdiccionales. @Mx_Diputados "/>
          </div>
          <p class="has-text-justified">Realizamos pocisionamiento de los partidos sobre exhorto a autoridades que ejercen funciones jurisdiccionales. @Mx_Diputados </p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion23.jpg" alt="Se presentó ante @Mx_Diputados la reforma al art. 132 de la Ley Federal del Trabajo. #LegislandoContigo"/>
          </div>
          <p class="has-text-justified">Se presentó ante @Mx_Diputados la reforma al art. 132 de la Ley Federal del Trabajo. #LegislandoContigo</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion24.jpg" alt="Presenté la iniciativa de reforma a la Ley General de Cultura y Derechos Culturales ante el Pleno de @Mx_Diputados."/>
          </div>
          <p class="has-text-justified">Presenté la iniciativa de reforma a la Ley General de Cultura y Derechos Culturales ante el Pleno de @Mx_Diputados.</p>
        </div>

      </div>

      <div class="columns mt-01">

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion25.jpg" alt="Además, plantea un marco regulatorio que determine las facultades del gobierno en materia de cultura, sus alcances y sus límites."/>
          </div>
          <p class="has-text-justified">Además, plantea un marco regulatorio que determine las facultades del gobierno en materia de cultura, sus alcances y sus límites.</p>
        </div>

        <div class="column is-4">
          <div class="video-container">
            <img src="assets/img/sesiones/sesion26.jpg" alt="Esta reforma es producto de la reforma constitucional del 2009 que garantiza la cultura como uno de los derechos de los mexicanos."/>
          </div>
          <p class="has-text-justified">Esta reforma es producto de la reforma constitucional del 2009 que garantiza la cultura como uno de los derechos de los mexicanos.</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'SesionesOrdinarias',
  data () {
    return {
    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SesionesOrdinarias.vue